export const navigationButtonStyles = {
  justifyContent: 'flex-start',
  minHeight: 48,
  borderRadius: 0,
  width: '100%',
  '&:focus-visible': {
    outline: '2px solid var(--color-white)',
    zIndex: 1,
  },
};
